/**
 * Credit and the running release, at the bottom of every page.
 *
 * The version is the one the bundle was built as, not one read at runtime: it
 * is what the dashboard reports its own errors under, and someone quoting it
 * from a screenshot should get the same answer.
 */
export function Footer() {
  return (
    <footer className="py-6 text-center text-xs text-muted-foreground">
      Built by{' '}
      <a
        href="https://www.peaky.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-foreground underline-offset-4 hover:underline"
      >
        Peaky
      </a>
      <span aria-hidden> · </span>
      <span title="Outpost version">{displayVersion(__APP_VERSION__)}</span>
    </footer>
  );
}

/** Release tags carry a leading "v"; a local build's "dev" should not. */
function displayVersion(version: string): string {
  return /^\d/.test(version) ? `v${version}` : version;
}
